import { useEffect } from "react";
import { useMeta } from "hooks";

interface MetaShape {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  image?: string;
  cover_image?: string;
}

export const usePageMeta = (meta?: MetaShape | null) => {
  const { setMetaTags } = useMeta();

  useEffect(() => {
    if (!meta) return;
    setMetaTags(meta);
  }, [meta, setMetaTags]); // ✅ stable reference, no infinite loop
};